export const COLOR = {
  white: '#fff',
  coal: '#181818',
  coal80: 'rgba(24, 24, 24, 0.8)',
  grey: '#a1abb0',
  mist: '#e2e5e2',
  mist50: 'rgba(226, 229, 226, 0.5)',
  mistLight: '#f7f9f8',
  green: '#6d7b1f',
  green50: 'rgba(109, 123, 31, 0.5)',
  greenLight: '#a9ad57',
  greenLighter: '#c2c589',
  greenBright: '#889340',
  greenDeep: '#394804',
  greenLight70: 'rgba(169, 173, 87, 0.7)',
  greenLight80: 'rgba(169, 173, 87, 0.8)',
  turquoize: '#b4d8d8',
  turquoizeBright: '#81afac',
  turquoizeLightest: '#c6dada',
  turquoizeDeep: '#569695',
  atmo: '#b8cdcc',

  cyan: '#B4F1DB',
  yellow: '#F19915',
  whiteV2: '#FBFBFB',
  charcoal: '#272727',
  stone1: '#C0B8AB',
  stone2: '#E5E0D7',
  stone3: '#F3EDE5',
  

}
